import * as _ from "lodash-es";
import { BaseModel } from "./base.model";
import { IUser } from "./users.model";
import { RequestType } from "../LIVECO.define";
import { ISftpConfig, SftpConfigHandler } from "./sftp.model";

export interface IMarque {
    _id?: string;
    label: string;
    IDSociete: number;
    archive: boolean;
    UUID: string;
    flags: any & { easydiadem?: boolean | RequestType[]; } & { categories?: boolean | object; };
    theme?: {
        topbarBackground?: string;
        topbarText?: string;
        accentColor?: string;
        showLogoInTopbar?: boolean;
        showLogoPaddingInTopbar?: boolean;
        showDiademLogoInTopbar?: boolean;
        showTeamCreatifLogoInTopbar?: boolean;
    };
    sftp: SftpConfigHandler;
}


export class Marque extends BaseModel<IMarque> implements IMarque {
    label: string;
    IDSociete: number;
    archive: boolean;
    UUID: string;
    flags: any & { easydiadem?: boolean | RequestType[]; } & { categories?: { [key: string]: string[]; }; } = {};
    theme: {
        topbarBackground?: string;
        topbarText?: string;
        accentColor?: string;
        showLogoInTopbar?: boolean;
        showLogoPaddingInTopbar?: boolean;
        showDiademLogoInTopbar?: boolean;
        showTeamCreatifLogoInTopbar?: boolean;
    } = {};
    sftp: SftpConfigHandler = new SftpConfigHandler({});


    constructor(data: Partial<IMarque>) {
        super(data);
        this.init(data);
    }
}
